import { IonPage, IonContent, IonCard, IonCardHeader, IonCardTitle, IonCardContent } from '@ionic/react';
import { useIsMobile } from '../hooks/useMediaQuery';

export function PlansPage() {
  const isMobile = useIsMobile();

  return (
    <IonPage>
      <IonContent className="page-content bg-gray-50">
        <div className={`page-header ${isMobile ? 'page-header-mobile' : 'page-header-desktop'}`}>
          <div className="title">Subscription</div>
        </div>
      </IonContent>
    </IonPage>
  );
}

